var _path, _defs;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgMarketuparrow(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 19,
    height: 11,
    viewBox: "0 0 19 11",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M0.172188 9.58416L0.279062 9.46378L8.35406 0.492966C8.62719 0.189161 9.03687 0 9.49406 0C9.95125 0 10.3609 0.194894 10.6341 0.492966L18.7031 9.44659L18.8397 9.59562C18.9406 9.73893 19 9.91089 19 10.0943C19 10.593 18.5606 11 18.0144 11H0.985625C0.439375 11 0 10.593 0 10.0943C0 9.90516 0.0653126 9.72746 0.172188 9.58416Z",
    fill: "url(#paint0_linear_5007_23498)"
  })), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint0_linear_5007_23498",
    x1: 9.5,
    y1: 11,
    x2: 9.5,
    y2: 0,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#00C1CE"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#82EBA1"
  })))));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgMarketuparrow);
export default __webpack_public_path__ + "static/media/marketuparrow.0b6614b11c7e485091e15291c8efbc5f.svg";
export { ForwardRef as ReactComponent };